export default "__VITE_ASSET__BZQh2W04__"